import api from './axiosInstance';

export const priceBookApi = {
  listPriceBooks: () => api.get('/price-books'),
  getPriceBook: id => api.get(`/price-books/${id}`),
  createPriceBook: data => api.post('/price-books', data),
  updatePriceBook: (id, data) => api.put(`/price-books/${id}`, data),
  deletePriceBook: id => api.delete(`/price-books/${id}`),

  // Price resolution
  resolvePrice: (catalogItemId, serviceCatalogItemId) =>
    api.get('/price-books/resolve-price', { params: { catalogItemId, serviceCatalogItemId } }),

  // Items
  listItems: priceBookId => api.get(`/price-books/${priceBookId}/items`),
  addItem: (priceBookId, data) =>
    api.post(`/price-books/${priceBookId}/items`, data),
  updateItem: (priceBookId, itemId, data) =>
    api.put(`/price-books/${priceBookId}/items/${itemId}`, data),
  removeItem: (priceBookId, itemId) =>
    api.delete(`/price-books/${priceBookId}/items/${itemId}`),
};
